import * as server from "@/utils/http"

export const _list = params => server.get("/general-inspection/list", params);
